import React from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import "./Footer.css"; // Add styles for the footer

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <section className="disclaimer">
          <p className="risk-factor">
            <b>Risk Factors : </b>
            Investments in Mutual Funds are subject to Market Risks. Read all
            scheme-related documents carefully before investing. Mutual Fund
            Schemes do not assure or guarantee any returns. Past performances of
            any Mutual Fund Scheme may or may not be sustained in future. There
            is no guarantee that the investment objective of any suggested
            scheme shall be achieved. All existing and prospective investors are
            advised to check and evaluate the Exit loads and other cost
            structure (TER) applicable at the time of making the investment
            before finalizing on any investment decision for Mutual Funds
            schemes. We deal in Regular Plans only for Mutual Fund Schemes and
            earn a Trailing Commission on client investments. Disclosure For
            Commission earnings is made to clients at the time of investments.
            Option of Direct Plan for every Mutual Fund Scheme is available to
            investors offering advantage of lower expense ratio. We are not
            entitled to earn any commission on Direct plans. Hence we do not
            deal in Direct Plans.
          </p>
        </section>
        {/* organization Section */}

        <div className="footer-section reduced-width-footer-section">
          <h3 className="footer-title">Organization</h3>
          <ul className="footer-links">
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/investor-education">Investor Education</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
            <li>
              <a
                href="https://drive.google.com/drive/folders/1HnJ-HZbxQurtovFU9zeDYCx8HuAmhGPz?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                General Disclosure
              </a>
            </li>
          </ul>
        </div>

        {/* Services Section */}
        <div className="footer-section reduced-width-footer-section">
          <h3 className="footer-title">Services</h3>
          <ul className="footer-links">
            <li>
              <Link to="/services/financial-planning">Financial Guidance</Link>
            </li>
            <li>
              <Link to="/services/mutual-funds">Mutual Fund</Link>
            </li>
            <li>
              <Link to="/services/estate-planning">Estate Guidance</Link>
            </li>
            <li>
              <Link to="/services/tax-planning">Tax Guidance</Link>
            </li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-section">
          <h3 className="footer-title">Contact Us</h3>
          <ul className="contact-list">
            <li>
              <strong>Phone: </strong>
              <a href="tel:9415762826">+91 9415762826</a>
            </li>
            <li>
              <strong>Email: </strong>
              <a href="mailto: awasthi.manjul@gmail.com">
                awasthi.manjul@gmail.com
              </a>
            </li>
            <li>
              <strong>Address: </strong>
              <br />
              Manjul Awasthi,
              <br />
              GF-18, Shivani Plaza,
              <br />
              Near Aliganj Hanuman Mandir,
              <br />
              Kapoorthala Crossing, Aliganj,
              <br />
              Lucknow, Uttar Pradesh-226024
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3 className="footer-title">An AMFI Registered MF Distributor</h3>
          <ul className="footer-links">
            <li>
              <b>Registered Name -</b> Manjul Awasthi
            </li>
            <li>AMFI Registration Number (ARN) - 30031</li>
            <li>Current validation of ARN - 29-Jan-2027</li>
          </ul>
        </div>

        {/* Location Section */}
        <div className="footer-section">
          <h3 className="footer-title">Our Location</h3>
          <div className="footer-map">
            <iframe
              title="Google Map"
              width="100%"
              height="170"
              src="https://maps.google.com/maps?width=100%&height=600&hl=en&q=Shivani%20Plaza%2C%20%20Near%20Aliganj%20Hanuman%20Mandir%2C%20Kapoorthala%20Crossing%2C%20%20Aliganj%20%20Lucknow%20%20Uttar%20Pradesh%20226024+(United%20Investment%20Point)&ie=UTF8&t=&z=16&iwloc=B&output=embed"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Bottom Footer Section */}
      <div className="footer-bottom">
        <p>&copy; United Investment Point. All rights reserved.</p>
        <ul className="footer-bottom-links">
          <li>
            <a
              href="https://www.amfiindia.com/aboutamfi?tab=members"
              target="_blank"
              rel="noopener noreferrer"
            >
              Partners' Details
            </a>
          </li>
          <p className="footer-link-separator">|</p>
          <li>
            <Link
              target="_blank"
              to="https://www.sebi.gov.in/sebiweb/home/HomeAction.do?doListing=yes&sid=1&ssid=7&smid=0"
            >
              SEBI Circulars
            </Link>
          </li>
          <p className="footer-link-separator">|</p>
          <li>
            <Link
              target="_blank"
              to="https://www.sebi.gov.in/filings/mutual-funds.html"
            >
              SID/SAI/KIM
            </Link>
          </li>
          <p className="footer-link-separator">|</p>
          <li>
            <Link to="/grievance-redressal">Grievance Redressal</Link>
          </li>
          <p className="footer-link-separator">|</p>
          <li>
            <Link
              target="_blank"
              to="https://resources.investwellonline.com/due-diligence/AMFI_Code-of-Conduct.pdf"
            >
              Code of Conduct{" "}
            </Link>
          </li>
          <p className="footer-link-separator">|</p>
          <li>
            <Link to="/disclaimer">Disclaimer</Link>
          </li>
          <p className="footer-link-separator">|</p>
          <li>
            <Link to="/disclosure">Disclosure</Link>
          </li>
          <p className="footer-link-separator">|</p>
          <a
            href="https://www.amfiindia.com/otherdata/fund-performance"
            target="_blank"
            rel="noopener noreferrer"
          >
            Fund Performance & More
          </a>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
